import { Datepicker } from 'vanillajs-datepicker'
import sk from 'vanillajs-datepicker/locales/sk'
import axios from 'axios'

import { throttle, right, setElHeight } from './Vue/functions/helpers'

document.onreadystatechange = () => {

    if ( document.readyState === 'complete' ) {

        const viewport = window.innerWidth

        // open modal by id
        function openModal(id) {
            document.getElementById(id).classList.add('open')
            document.body.classList.add('jw-modal-open')
        }

        // close currently open modal
        function closeModal() {
            let modalOPen = document.querySelector('.jw-modal.open')

            if ( modalOPen ) {
                modalOPen.classList.remove('open')
                document.body.classList.remove('jw-modal-open')
            }
        }

        window.addEventListener('load', function() {
            // close modals on background click
            document.addEventListener('click', event => {
                if (event.target.classList.contains('jw-modal')) {
                    closeModal()
                }
            })
        })

        const datepickerInput = document.querySelector('#js-datepicker input')

        if ( datepickerInput ) {

            Object.assign(Datepicker.locales, sk)

            const datepicker = new Datepicker(datepickerInput, {
                language: 'sk'
            })
        }

        var langSwitch = document.getElementById("current-language")
        var langList = document.getElementById("language-switch-list")

        if(langSwitch){
            langSwitch.onclick = function (e) {

                langSwitch.classList.toggle('active')
                langList.classList.toggle("active")
            }
        }

        var currencySwitch = document.getElementById("current-currency")
        var currencyList = document.getElementById("currency-switch-list")
        var currencyOptions = document.querySelectorAll("#currency-switch-list > li > a")

        if(currencySwitch){
            currencySwitch.onclick = function (e) {

                currencySwitch.classList.toggle('active')
                currencyList.classList.toggle("active")
            }

            for (const currencyOption of currencyOptions) {
                currencyOption.addEventListener('click', function(e) {
                    var modalId = this.getAttribute("data-modal-id")
                    var currencyId = this.getAttribute("data-currency")
                    var modal = document.getElementById(modalId);
                    var currencyModalCloseBtn = modal.querySelector(".close")

                    modal.querySelector("input[name=currency]").value = currencyId;
                    modal.classList.add("active");

                    currencyModalCloseBtn.onclick = function (e) {

                        modal.classList.remove('active')
                        modal.querySelector("input[name=currency]").value = null;
                    }
                })
            }
        }

        const deliveriesCart = document.querySelectorAll('.js-cart-delivery-step')
        const paymentsCart   = document.querySelectorAll('.js-cart-payment-step')

        if ( deliveriesCart && paymentsCart ) {

            const deliveryWrapper = document.getElementById('js-deliveries-wrapper')

            if ( deliveryWrapper ) {
                deliveryWrapper.style.display = 'block'
            }

            deliveriesCart.forEach( delivery => {
                delivery.addEventListener('click', function (e) {
                    let payments = JSON.parse(this.getAttribute('data-allowed-payments'))

                    // pri prekliku najprv vymaž, že bol vybraný wolt (ak bol predtým vybraný, session pre wolt sa vynuluje)
                    axios.post('/api/null-wolt-shipment-promise', {})
                        .then( response => {
                            // console.log(response)
                        }).catch( error => console.error(error))

                    if ( this.classList.contains('js-wolt') ) {
                        e.preventDefault()
                        let self = this

                        openModal('wolt-modal')

                        let woltModal = document.getElementById('wolt-modal')
                        let wolt_info_content = null
                        let wolt_free_coupon = woltModal.getAttribute('data-free-coupon')

                        // vymaž výstup
                        woltModal.querySelector('.js-dynamic-content').innerHTML = ''
                        woltModal.querySelector('.js-loader').style.display = 'block'

                        // vyresetuj wolt cenu
                        let wolt_price = document.querySelector('#wolt-calc-price')
                        let wolt_data_display = false
                        let wolt_calc_price = ''

                        // získaj shipment promise
                        axios.post('/api/get-wolt-shipment-promise', {})
                            .then( response => {
                                let wd = response.data.wolt_data
                                if (wd.info === '') {
                                    wolt_data_display = true
                                    let priceInfo = ''
                                    if (!wolt_free_coupon) {
                                        priceInfo = '<h5>' + wd.price_text + ' ' + (wd.show_price/100).toFixed(2) + ' ' + wd.currency + '</h5>'
                                        wolt_calc_price = (wd.show_price/100).toFixed(2) + ' ' + wd.currency
                                    }
                                    wolt_info_content = '<h5>' + wd.eta_text + ' ' + wd.eta + ' ' + wd.time_append +'</h5>' + priceInfo
                                }
                                else {
                                    wolt_data_display = false
                                    wolt_info_content = '<h5>' + wd.info + '</h5>'
                                }
                                // console.log(response)
                            }).catch( error => console.error(error))

                        setTimeout( () => {
                            // zobraz výstup
                            woltModal.querySelector('.js-dynamic-content').innerHTML = wolt_info_content

                            woltModal.querySelector('.js-loader').style.display = 'none'
                            woltModal.querySelector('.js-dynamic-content').style.display = 'block'
                        }, 1000)

                        woltModal.querySelector('.js-close').addEventListener('click', function(e) {
                            e.preventDefault()

                            // pri zatvorení modeálneho okna vymaž wolt session (ak bol predtým vybraný, session pre wolt sa vynuluje)
                            axios.post('/api/null-wolt-shipment-promise', {})
                                .then( response => {
                                    // console.log(response)
                                }).catch( error => console.error(error))

                            closeModal()
                        })

                        woltModal.querySelector('.js-confirm').addEventListener('click', function(e) {
                            e.preventDefault()
                            if (wolt_price && wolt_data_display) {
                                wolt_price.textContent = wolt_calc_price
                            }
                            closeModal()
                            self.querySelector('input').checked = true

                            if ( !self.getAttribute('data-canceled') ) {
                                paymentsCart.forEach( payment => {

                                    payment.setAttribute('data-canceled', true)
                                    payment.children[0].children[0].checked = false

                                    if ( !payments.includes(payment.getAttribute('data-id')) )
                                        payment.style.display = 'none'
                                    else
                                        payment.style.display = 'flex'
                                })
                            }

                        // setni inputy hidden podla potreby
                        })
                    }  else {
                        if ( !this.getAttribute('data-canceled') ) {
                            paymentsCart.forEach( payment => {

                                payment.setAttribute('data-canceled', true)
                                payment.children[0].children[0].checked = false

                                if ( !payments.includes(payment.getAttribute('data-id')) )
                                    payment.style.display = 'none'
                                else
                                    payment.style.display = 'flex'
                            })
                        }
                    }
                })
            })

            paymentsCart.forEach( payment => {
                payment.addEventListener('click', function (e) {
                    let id = this.getAttribute('data-id')

                    if ( !this.getAttribute('data-canceled') ) {
                        deliveriesCart.forEach( delivery => {
                            delivery.setAttribute('data-canceled', true)
                            delivery.children[0].children[0].checked = false
                            let payments = JSON.parse(delivery.getAttribute('data-allowed-payments'))

                            if ( payments.includes(id) )
                                delivery.style.display = 'flex'
                            else
                                delivery.style.display = 'none'
                        })
                    }
                })
            })
        }

        const categoryBanner = document.querySelector('.js-category-banner')

        if ( categoryBanner ) {

            // if ( isAppleSafari() ) {
            //     console.log('You are on Apple Safari web browser.');
            // } else {
            //     console.log('You are not on Apple Safari web browser.');
            // }

            let contentElement = categoryBanner.querySelector('.text'),

                //   lineHeight = parseFloat(window.getComputedStyle(contentElement, null).getPropertyValue('line-height')),
              // lines = contentElement.clientHeight / lineHeight,
              moreBtn = categoryBanner.querySelector('.js-more'),
              lessBtn = categoryBanner.querySelector('.js-less')

            const isTextClamped = element => element.scrollHeight > element.clientHeight

            if ( contentElement && isTextClamped(contentElement) ) {
                moreBtn.style.display = 'block'
            }

            if(moreBtn){
                moreBtn.addEventListener('click', function (e) {
                    categoryBanner.classList.add('active')
                    this.style.display = 'none'
                    lessBtn.style.display = 'block'
                })
            }

            if(lessBtn){
                lessBtn.addEventListener('click', function (e) {
                    categoryBanner.classList.remove('active')
                    this.style.display = 'none'
                    moreBtn.style.display = 'block'
                })
            }

            // const charLimit = viewport > 991 ? 450 : 250,
            //       ellipsis  = '...',
            //       maxLines = 5,
            //       html = categoryBanner.querySelector('.text').innerHTML,
            //       moreBtn = categoryBanner.querySelector('.js-more'),
            //       lessBtn = categoryBanner.querySelector('.js-less')
            //
            // if ( truncateText(categoryBanner.querySelector('.text'), maxLines) ) {
            //     moreBtn.style.display = 'block'
            // }

            // if ( html.length > charLimit ) {
            //     categoryBanner.querySelector('.text').innerHTML = getCutText(charLimit)
            //     moreBtn.style.display = 'block'
            // }

            // moreBtn.addEventListener('click', function (e) {
            //     categoryBanner.querySelector('.text').innerHTML = html
            //     this.style.display = 'none'
            //     lessBtn.style.display = 'block'
            // })
            //
            // lessBtn.addEventListener('click', function (e) {
            //     truncateText(categoryBanner.querySelector('.text'), maxLines)
            //     this.style.display = 'none'
            //     moreBtn.style.display = 'block'
            // })

            // function getCutText(limit) {
            //     return categoryBanner.querySelector('.text').innerHTML.slice(0, limit) + ellipsis
            // }

            // function truncateText(element, maxLines) {
            //     let text = element.innerHTML,
            //         lineHeight = parseInt(getComputedStyle(element).lineHeight),
            //         lines = element.clientHeight / lineHeight,
            //         isTruncated = lines > maxLines;
            //
            //     if ( lines > maxLines ) {
            //         let lastLineBreak = text.lastIndexOf(' ', text.length - 1 - (lines - maxLines) * (text.length / lines))
            //         let lastSpace = text.lastIndexOf(' ', lastLineBreak - 1)
            //         element.innerHTML = text.slice(0, lastSpace) + ' ...'
            //     }
            //
            //     return isTruncated
            // }
        }

        const formInputs   = document.querySelectorAll('form input:not(.filter-input)')
        const formTextarea = document.querySelectorAll('form textarea')
        const formSelects  = document.querySelectorAll('form select')

        if ( formInputs || formTextarea ) {

            if ( formInputs )
                formInputs.forEach( item => checkFormElementIfFilled(item))

            if ( formTextarea )
                formTextarea.forEach( item => checkFormElementIfFilled(item))

            if ( formSelects )
                formSelects.forEach( item => checkFormElementIfFilled(item))

            function checkFormElementIfFilled(formEl) {
                if ( formEl.value !== '' ) formEl.classList.add('filled')

                formEl.addEventListener('blur', function () {
                    if ( this.value.length )
                        this.classList.add('filled')
                    else
                        this.classList.remove('filled')
                })
            }
        }

        const companyInputsToggle = document.getElementById('js-firm-inputs')

        if ( companyInputsToggle ) {

            const firmInputs = document.getElementById('firm-inputs')

            if ( companyInputsToggle.classList.contains('open') ) handleFirmInputs()

            companyInputsToggle.addEventListener('click', function (e) {
                e.preventDefault()

                this.classList.toggle('open')

                if ( !firmInputs.classList.contains('open') ) {
                    handleFirmInputs()
                } else {
                    firmInputs.style.height = '0px'

                    firmInputs.addEventListener('transitionend', function () {
                        firmInputs.classList.remove('open')
                    }, { once: true })
                }
            })

            function handleFirmInputs() {
                firmInputs.classList.add('open')
                firmInputs.style.height = 'auto'

                let height = firmInputs.clientHeight + 'px'

                firmInputs.style.height = '0px'

                setTimeout( () => {
                    firmInputs.style.height = height
                }, 0)
            }
        }

        const addressToggle = document.getElementById('js-address-toggle')

        if ( addressToggle ) {
            const deliveryInputs = document.getElementById('delivery-inputs')

            if ( addressToggle.checked )
                deliveryInputs.style.display = 'none'

            addressToggle.addEventListener('change', function () {
                if ( this.checked )
                    deliveryInputs.style.display = 'none'
                else
                    deliveryInputs.style.display = 'block'
            })
        }

        const elToRight = document.querySelector('.js-to-right')

        if ( elToRight ) {

            if ( viewport > 991 ) {
                elToRight.style.marginRight = parseFloat('-'+ right(elToRight).toString())+'px'
            }

            window.addEventListener('resize', throttle(function () {
                if ( window.innerWidth > 991 ) {
                    elToRight.style.marginRight = parseFloat('-'+ right(elToRight).toString())+'px'
                }
            }, 100))
        }

        if ( document.querySelector('.block-product-listing.detail') && viewport > 575 ) {
            setElHeight(document.querySelectorAll('.block-product-listing.detail .product h4'))
            setElHeight(document.querySelectorAll('.block-product-listing.detail .product .bottom'))
        }

        const openContactForm = document.getElementById('js-contact-form')

        if ( openContactForm ) {

            const closeForm = document.getElementById('js-close-contact-form')
            const form      = document.getElementById('fixed-contact-form')

            openContactForm.addEventListener('click', function (e) {
                e.preventDefault()
                form.classList.add('visible')

                if ( viewport < 575 )
                    document.getElementById('overlay').classList.add('visible')
            })

            closeForm.addEventListener('click', function (e) {
                e.preventDefault()
                form.classList.remove('visible')

                if ( viewport < 575 )
                    document.getElementById('overlay').classList.remove('visible')
            })
        }

        if (  viewport < 991 ) {
            const fixedFilter = document.getElementById('js-fixed-filter')

            if ( fixedFilter ) {
                window.addEventListener('scroll', throttle(function () {
                    if ( window.scrollY > 400 ) fixedFilter.classList.add('visible')
                    else fixedFilter.classList.remove('visible')
                }, 50))
            }
        }

        const searchPage = document.querySelector('.js-search-page')

        if ( searchPage ) {
            setElHeight(document.querySelectorAll('.product h4'))
            setElHeight(document.querySelectorAll('.product .bottom'))
            setElHeight(document.querySelectorAll('.product .description'))
            setElHeight(document.querySelectorAll('.product .excerpt'))
        }

        const error419Page = document.getElementById('error-419-page');

        if (error419Page) {
            history.go(-1);
        }

        // const countersUp = document.querySelectorAll( '.js-count-up' )
        //
        // const intersectionCallback = entries => {
        //     entries .forEach( entry => {
        //         const el = entry.target
        //
        //         if ( entry.isIntersecting && !el.getAttribute('data-count-init') ) {
        //
        //             counterUp( el, {
        //                 duration: 2000,
        //                 delay: 16,
        //             })
        //
        //             el.setAttribute('data-count-init', true)
        //         }
        //     })
        // }
        //
        // const IO = new IntersectionObserver( intersectionCallback, { threshold: 1 } )
        //
        // countersUp.forEach( (item,index ) => IO.observe( item ))

        //
        // GTM STUFF
        //--------------------------------------------------------------------------------
        const gaElements = document.querySelectorAll('.js-ga-event')

        gaElements.forEach( (element) => {
            element.addEventListener('click', (e) => {

                let el = e.currentTarget

                window.dataLayer.push({
                    'event': 'customClickEvent',
                    'dataPageArea': el.getAttribute('data-page-area'),
                    'dataType': el.getAttribute('data-type'),
                    'dataName': el.getAttribute('data-name'),
                    'dataText': el.getAttribute('data-text'),
                    'dataAction': el.getAttribute('data-action'),
                    'dataDestinationUrl': el.getAttribute('data-destination-url'),
                    'gtm.element': el
                })
            })
        })

        if ( viewport > 991 ) {
            if ( document.getElementById('js-sidebar') ) {
                new StickySidebar('#js-sidebar', {
                    containerSelector: '#js-sidebar-column',
                    innerWrapperSelector: '.sidebar__inner',
                    topSpacing: 20,
                    bottomSpacing: 20
                })
            }
        }

        const pharmacies = document.querySelector('.js-pharmacies')

        if ( pharmacies ) {
            if ( viewport > 991 ) {
                setElHeight(document.querySelectorAll('.js-pharmacies article'))
            }
        }

        // API
        const regionListing = document.getElementById('js-regions')
        const pharmacyListing = document.getElementById('js-pharmacies')

        if ( regionListing ) {
            fetch(regionListing.getAttribute('data-url'), {
                method: 'GET'
            }).then(function (response) {
                return response.text();
            }).then(function (html) {
                regionListing.querySelector('.js-regions-results').innerHTML = html

                const itemFilter = document.querySelector('.js-item-filters')
                if ( itemFilter ) {
                    itemFilter.querySelectorAll('button').forEach( button => {
                        button.addEventListener('click', function (e) {
                            e.preventDefault()
                            let targetFilter = this.getAttribute('data-target')

                            if (targetFilter === "0") {
                                document.querySelectorAll(`.js-item-filter-target [data-target]`).forEach(
                                    item => item.style.display = 'block'
                                )
                                return
                            }

                            document.querySelectorAll('.js-item-filter-target [data-target]').forEach(
                                item => item.style.display = 'none'
                            )

                            document.querySelectorAll(`.js-item-filter-target [data-target="${targetFilter}"]`).forEach(
                                item => item.style.display = 'block'
                            )
                        })
                    })
                }
            }).catch(function (err) {
                console.warn(err);
            });
        }
        if ( pharmacyListing ) {
            fetch(pharmacyListing.getAttribute('data-url'), {
                method: 'GET'
            }).then(function (response) {
                return response.text();
            }).then(function (html) {
                pharmacyListing.querySelector('.js-pharmacies-results').innerHTML = html
            }).catch(function (err) {
                console.warn(err);
            });
        }
    }

    const woltCategoriesHolder   = document.getElementById('js-wolt-categories-holder')

    if ( woltCategoriesHolder ) {
        const woltCategoriesBody= woltCategoriesHolder.getAttribute('data-body')
        const woltCategoriesUrl= woltCategoriesHolder.getAttribute('data-url')

        fetch(woltCategoriesUrl, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: woltCategoriesBody,
        }).then(function (response) {
            console.log(response)
            return response.text();
        }).then(function (html) {
            woltCategoriesHolder.innerHTML = html
        }).catch(function (err) {
            console.warn(err);
        });
    }
}
